import RoundedBoxComponent from "../race/block/RoundedBoxComponent.jsx";
import { COLORS } from "../../constants/colors";

const WallPyramid = ({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  color = COLORS.orange,
}) => {
  const wallSize = 5;
  const cubeSize = 0.4; // Размер кубика
  const spacing = 0.01; // Уменьшили расстояние между кубиками
  const radius = 0;
  const totalSize = cubeSize + spacing;

  return (
    <group position={position} rotation={rotation}>
      {Array.from({ length: wallSize }, (_, row) =>
        Array.from({ length: wallSize }, (_, col) => (
          <RoundedBoxComponent
            key={`${row}-${col}`}
            position={[
              (col - wallSize / 2) * totalSize,
              (row - wallSize / 2) * totalSize,
              0,
            ]}
            size={cubeSize}
            radius={radius}
            mass={0.1} // Увеличили массу для стабильности
            friction={0.8} // Увеличили трение
            restitution={0.1} // Уменьшили упругость
            linearDamping={0.5} // Увеличили затухание
            angularDamping={0.8} // Увеличили затухание вращения
            color={color}
          />
        ))
      )}
    </group>
  );
};

export default WallPyramid;
